import React from "react"
import styled from "styled-components"
import Spinner from "../shared/Spinner"
import { Button } from "./styles"

export const Next = styled(Button)`
  margin-left: auto;
  grid-column: 3/4;
  padding: 5px 5px 5px 15px;
  display: grid;
  grid-template-columns: auto 15px;
  align-items: center;
`

export const NextButton = props => {
  const { children, disabled, pending, onClick } = props
  return (
    <Next onClick={onClick} disabled={disabled}>
      <div>{children}</div>
      <div>{pending && <Spinner small />}</div>
    </Next>
  )
}
